<div class="preloader">
    <div class="loader">
        <img src="assets/icons/logo-white.svg" alt="Tudi Logo" class="logo">
    </div>
</div>